export default __webpack_public_path__ + "static/media/image.envicta-pvt-ltd.805d0a90.png";